import { FormikValues, getIn, useFormikContext } from 'formik'
import { errorId } from './FieldFrame'

// Field-keyed messages from a failed save, kept in Formik's status until the field is edited
export interface ServerErrorsStatus {
  serverErrors?: Record<string, string>
}

// Client-side errors show once a field is touched or the form was submitted; server errors show
// until the field is edited.
export const useFieldError = (name: string) => {
  const { errors, touched, status, submitCount, setStatus } =
    useFormikContext<FormikValues>()
  const formStatus: ServerErrorsStatus = status ?? {}
  const clientError: unknown = getIn(errors, name)
  const visibleClientError =
    typeof clientError === 'string' && (getIn(touched, name) || submitCount > 0)
      ? clientError
      : undefined
  const error = visibleClientError ?? formStatus.serverErrors?.[name]

  const clearServerError = () => {
    if (!formStatus.serverErrors?.[name]) return

    const { [name]: _cleared, ...serverErrors } = formStatus.serverErrors
    setStatus({ ...formStatus, serverErrors })
  }

  return {
    error,
    clearServerError,
    describedBy: error ? errorId(name) : undefined,
    invalid: error ? true : undefined
  }
}
